
export enum HeaderBarMessageType {
    Status,
    Progress,
    Done,
    Error,
    Warning,
    Information
};

export class HeaderBarMessageHeaderInfo {
    /** 
     * Show/Hide the header bar icon 
     */
    showIcon: boolean = true;
    /** 
     * Show/Hide progress bar 
     */
    showProgress: boolean = false;
    /** 
     * Show/Hide stop button 
     */
    showStop: boolean = false;
    /** 
     * Show/Hide the up caret - which hides the header bar message details 
     */
    showCaretUp: boolean = false;
    /** 
     * Show/Hide the down caret - which shows the  header bar message bar details
     */
    showCaretDown: boolean = false;
    /** 
     * Show/Hide the header bar close icon - chich closed the header bar message 
     */
    showClose: boolean = true;
    /**
     * Whether the header bar is expanded (true) or collapsed (false)
     */
    isExpanded: boolean = false;

    clear(): void {
        this.showIcon = false;
        this.showProgress = false;
        this.showStop = false;
        this.showCaretUp = false;
        this.showCaretDown = false;
        this.showClose = false;
    }
}

/**
 * Base message information
 */
export class HeaderBarMessageInfo extends HeaderBarMessageHeaderInfo {
    /**
     * Message type
     */
    messageType: HeaderBarMessageType = HeaderBarMessageType.Status;
    /**
     * Message Text
     */
    message: string = "";

    /**
     * Message icon
     */
    messageIcon = "";

    constructor() {
        super();
    }

    clear(): void {
        this.messageType = HeaderBarMessageType.Status;
        this.message = "";
        this.messageIcon = "";
        super.clear();
    }
}
